// Helper function to format property reference - always show RTB format
export const formatPropertyRef = (ref, fallback = null) => {
  if (!ref) return fallback || "RTB-PENDING";
  if (ref.startsWith("RTB-")) return ref;
  if (ref.startsWith("PROP-")) return ref.replace("PROP-", "RTB-");
  return `RTB-${ref}`;
};
